export default __webpack_public_path__ + "static/23_32-dc1a3b525e1377681de0e70f55e2b973.png";